<template>
  <div class="page_main">
    <Spin fix size="large" v-if="table_loading"></Spin>

    <div class="page_tabs">
      <div class="search_div">
        <Input
          v-model="search_value"
          clearable
          search
          @on-enter="search_click"
          size="small"
          placeholder="搜索姓名"
          style="width: 100px"
        />
      </div>
      <div>
        <Tabs size="small" :v-model="tabs_index" @on-click="click_tabs">
          <TabPane
            v-for="(item, i) in flow_class_list"
            :key="i"
            :name="item.value"
            :label="item.label"
          >
          </TabPane>
        </Tabs>
      </div>
      <div class="button_operation">
        <div v-if="is_action" class="button_1">
          <Button
            @click="click_action(item)"
            :loading="button_loading"
            v-for="(item, i) in action_list"
            :key="i"
            size="small"
            style="font-size: 12px; margin-right: 10px"
            type="primary"
            >{{ item.label }}
          </Button>
        </div>
        <Button
          @click="click_get_back"
          v-if="tabs_index == 'FLOW_11A8A' || tabs_index == 'FLOW_4C09A'"
          size="small"
          style="font-size: 12px; margin-left: 10px"
          type="warning"
        >
          <Icon type="ios-arrow-dropleft" /> 返回上一步
        </Button>
      </div>
    </div>

    <div class="table_div">
      <Table
        size="small"
        :height="windowHeight - 185"
        :columns="columns"
        :data="table_data"
        @on-selection-change="tabs_selection_change"
      >
        <template #name="{ row }">
          <span class="name" @click="click_name(row)">{{ row.name }}</span>
        </template>

        <template #belong_name="{ row }"
          ><span class="belong_name" :title="row.belong_phone">{{
            row.belong_name
          }}</span>
        </template>
        <template #idcard="{ row }">
          <span class="idcard2" @click="click_idcard_num(row)">{{ row.idcard }}</span>
          <i
            title="已实名"
            v-if="row.is_certification == 1"
            class="iconfont iconrenzheng"
          ></i>
          <i
            title="未实名"
            v-else
            class="iconfont iconweirenzheng"
            @click="click_update_certification(row)"
          ></i>
        </template>
        <template #phone="{ row }">
          <div @click="click_update_phone(row)">
            <span class="phone_span">{{ row.phone }}</span>
            <Icon
              class="phone_icon"
              
              type="ios-create-outline"
            />
          </div>
        </template>
        <template #job_name="{ row }">
          <span class="idcard_num" @click="click_job_name(row)"
            >{{ row.job_name }}

            <Icon type="ios-create-outline" size="14" color="#0466dd" />
          </span>
        </template>
        <template #remarks="{ row }">
          <span class="idcard_num" @click="click_update_remarks(row)"
            >{{ row.remarks }}

            <Icon type="ios-create-outline" size="14" color="#0466dd" />
          </span>
        </template>
      </Table>
      <div class="content_page">
        <Page
          show-elevator
          show-total
          :total="total_count"
          v-model="page"
          :page-size="limit"
          @on-change="page_change"
        />
      </div>
    </div>

    <Modal v-model="action_show" title="操作警告" :footer-hide="true">
      <Spin fix v-if="loading_action_affirm"></Spin>
      <div class="action_div_title">
        确认要更新状态为【 {{ action_item.label }} 】吗?
        <br />
        更新状态将无法修改，强烈建议检查无误后确认！
      </div>
      <!-- <div class="remarks_div">
        <span>备注：</span>
        <Input
          type="textarea"
          size="small"
          v-model="action_remarks"
          placeholder="请输入备注(选填)"
          style="width: 300px"
        />
      </div> -->
      <div class="action_button_div">
        <Button type="primary" @click="click_action_affirm">确认更新</Button>
      </div>
    </Modal>

    <!-- 更新手机号 -->
    <Modal v-model="update_phone_show" title="更新手机号" :footer-hide="true" width="300">
      <div>
        <Input
          maxlength="11"
          v-model="update_phone_value"
          placeholder="输入11位手机号码"
          style="width: 200px"
        />
      </div>
      <div class="update_phone_button">
        <Button type="primary" @click="update_phone">确认更新</Button>
      </div>
    </Modal>
    <update_idcard @change="update_idcard_change" ref="update_idcard"></update_idcard>

    <update_job_name
      @change="update_job_name_change"
      ref="update_job_name"
    ></update_job_name>

    <resume_detail ref="resume_detail"></resume_detail>
    <interview_update_phone ref="interview_update_phone" @change="interview_update_phone_change"></interview_update_phone>


    <update_remarks @change="update_remarks_change" ref="update_remarks"></update_remarks>
  </div>
</template>

<script>
import { http } from "@/utils/http.js";
import merge from "webpack-merge";
import watermark from "@/utils/shuiyin.js";
import update_idcard from "@/views/roster_manage/component/update_idcard2.vue";
import update_job_name from "../roster/update_job_name.vue";
import update_remarks from "../roster/update_remarks.vue";
import resume_detail from "@/views/roster_manage/component/resume_detail.vue";
import interview_update_phone from '@/views/roster_manage/component/update_phone.vue'

export default {
  components: {
    update_idcard,
    update_job_name,
    update_remarks,
    resume_detail,
    interview_update_phone
  },
  props: ["project_id"],
  name: "daimianshi",

  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      flow_class_list: [],
      tabs_index: "",

      //表格
      table_loading: false,
      columns: [],
      table_data: [],
      page: 1,
      limit: 20,
      total_count: 0,
      table_selection: [],
      //按钮列表
      is_action: false,
      action_list: [],
      search_type: "name",
      search_value: "",
      action_item: {},
      action_show: false,
      action_remarks: "",
      loading_action_affirm: false,

      project_id: "",
      project_name: "",
      tabs_append: "",

      // 更新手机号
      update_phone_show: false,
      update_phone_value: "",
      update_phone_item: {},
      // 按钮加载
      button_loading:false
    };
  },

  mounted() {
    this.window_change();
  },

  methods: {
    update_remarks_change() {
      this.get_mianshizhong_list();
    },

    click_update_remarks(row) {
      this.$refs.update_remarks.open(this.project_id, row);
    },

    // 更新岗位
    click_job_name(row) {
      this.$refs.update_job_name.open(this.project_id, row);
    },

    update_job_name_change() {
      this.get_mianshizhong_list();
    },

    click_update_phone(row) {
      this.$refs.interview_update_phone.open(row)
    },

    interview_update_phone_change(){
      this.get_mianshizhong_list()
    },


    click_get_back() {
      var that = this;

      this.$Modal.confirm({
        title: "提示",
        content:
          "<p>返回上一步后当前状态会删除，员工会恢复到上一步【待操作】状态，操作后无法恢复，真的要继续吗？</p>",
        onOk: () => {
          that.get_back_affirm();
        },
        onCancel: () => {},
      });
    },

    //返回上一步
    get_back_affirm() {
      var interview_id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var ivid = this.table_selection[i]["interview_id"];
        interview_id_list.push(ivid);
      }

      if (interview_id_list.length == 0) {
        this.$Message.error("请至少选择一位");
        return;
      }

      var that = this;
      var obj = {
        project_id: this.project_id,
        interview_id_list: interview_id_list,
        flow_id: this.tabs_index,
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/get_back", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_mianshizhong_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    open() {
      var that = this;
      var query = this.$route.query;
      if (query.flow_id) {
        this.tabs_index = query.flow_id;
      }
      if (query.project_id) {
        this.project_id = query.project_id;
      }
      if (query.project_name) {
        this.project_name = query.project_name;
      }
      if (query.tabs_append) {
        this.tabs_append = query.tabs_append;
      }

      this.get_flow_class_list();
      this.create_shuiyin();
    },

    //点击更新实名
    click_update_certification(item) {
      var resume_id = item.resume_id;
      var that = this;
      this.$Modal.confirm({
        title: "实名检测",
        content: "<p>确认要对姓名跟身份证进行实名校验吗?" + "</p>",
        onOk: () => {
          that.update_certification_request(resume_id);
        },
        onCancel: () => {},
      });
    },

    update_certification_request(resume_id) {
      var that = this;
      var obj = {
        resume_id: resume_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/certification",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_mianshizhong_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //点击身份证号
    click_idcard_num(item) {
      this.$refs.update_idcard.open(item);
    },

    update_idcard_change() {
      this.get_mianshizhong_list();
    },

    //点击搜索
    search_click() {
      this.page = 1;
      this.get_mianshizhong_list();
    },
    create_shuiyin() {
      var user_info = window.localStorage.getItem("user_info");
      if (user_info) {
        var user_info_dict = JSON.parse(user_info);
        var name = user_info_dict.name;
        watermark.set("保密信息-" + name, "220px");
      }
    },
    click_tabs(e) {
      this.tabs_index = e;
      this.get_mianshizhong_list();
      this.get_action_list();
    },

    click_action_affirm() {
      this.click_action_request(this.action_item);
    },

    click_action(item) {
      this.action_item = item;
      this.action_show = true;
      // var that = this
      // this.$Modal.confirm({
      //     title: '操作警告',
      //     content: '<p>确认要更新状态为【' + item.label + '】吗，更新状态将无法修改，强烈建议检查无误后确认！</p>',
      //     onOk: () => {
      //         that.click_action_request(item)
      //     },
      //     onCancel: () => {

      //     }
      // });
    },

    //点击操作按钮,下一个流程
    click_action_request(item) {
      var interview_id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var interview_id = this.table_selection[i]["interview_id"];
        interview_id_list.push(interview_id);
      }
      if (interview_id_list.length == 0) {
        this.$Message.error("请至少选择一行");
        return;
      }
      if (item.value == "") {
        this.$Message.error("flow_id异常");
        return;
      }
      var that = this;
      var obj = {
        flow_id: item.value,
        current_flow_id: this.tabs_index,
        interview_id_list: interview_id_list,
        remarks: this.action_remarks,
      };

      this.loading_action_affirm = true;
      this.button_loading=true
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/mianshizhong/next_flow",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.action_show = false;
            that.get_flow_class_list();
            that.action_remarks = "";
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading_action_affirm = false;
          that.button_loading=false
        })
        .catch((res) => {
          that.loading_action_affirm = false;
          that.button_loading=false
          console.log(res, "请求出错");
        });
    },

    //表格选项变化
    //点击小勾
    tabs_selection_change(e) {
      this.table_selection = e;
    },

    //获取按钮列表
    get_action_list() {
      var that = this;
      var obj = {
        flow_id: this.tabs_index,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/mianshizhong/action_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.action_list = res.data.action_list;
            that.is_action = res.data.is_action;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取面试中列表
    get_mianshizhong_list() {
      var that = this;
      var obj = {
        page: this.page,
        project_id: this.project_id,
        flow_id: this.tabs_index,
        search_type: this.search_type,
        search_value: this.search_value,
      };
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/my_project/mianshizhong/list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.columns = res.data.columns;
            that.table_data = res.data.resume_list;
            that.limit = res.data.limit;
            that.total_count = res.data.total_count;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    //获取流程类
    get_flow_class_list() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };

      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/mianshizhong/flow_class_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.flow_class_list = res.data.flow_class_list;
            that.tabs_index = that.flow_class_list[0]["value"];
            console.log(this.tabs_index);
            that.get_mianshizhong_list();
            that.get_action_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    page_change(e) {
      this.page = e;
      this.get_mianshizhong_list();
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },

    click_name(row) {
      this.$refs.resume_detail.open(row, this.project_id);
    },
  },
};
</script>

<style scoped>
.idcard2{
  color: #0466dd;
  cursor: pointer;
}
.phone_span{
  color: #0466dd;
  cursor: pointer;
}

.name {
  color: #0466dd;
  cursor: pointer;
}

.button_1 {
  display: flex;
  align-items: center;
}

.update_phone_button {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.phone_icon {
  font-size: 14px;
  cursor: pointer;
  margin-left: 3px;
}
.phone_icon:hover {
  color: #0073ff;
}

.idcard_num {
  cursor: pointer;
}

.idcard_num:hover {
  color: #0466dd;
}

.action_button_div {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.action_div_title {
  font-weight: 600;
}

.remarks_div {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.search_div {
  margin-bottom: 5px;
}

.iconweirenzheng {
  font-size: 12px;
  color: #fb0000;
  margin-left: 3px;
  cursor: pointer;
}

.iconrenzheng {
  font-size: 10px;
  color: #01b729;
  margin-left: 3px;
  cursor: pointer;
}

.belong_name {
  color: #0466dd;
  cursor: pointer;
}

.table_div {
  position: relative;
}

.hengxian {
  border-top: 1px dashed #ececec;
  margin: 10px 0;
}

.field_item_box {
  display: flex;
  width: 800px;
  padding-left: 10px;
}

.content_page {
  padding: 8px 0 7px 0;
  text-align: center;
}

.page_tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.page_main {
  padding: 0 10px 0px 10px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
}

.add_resume_button_opertion {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.field_title {
  width: 100px;
  flex-shrink: 0;
}

.field_item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 20px;
}

.button_operation {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  width: 100px;
}
</style>
